import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize';
import * as actionsLinePicking from '../../../../../actions/linePickingAction';
import ListItemOrder from './ListItemOrder';
import ConfirmModal from '../../../../../components/UI/ConfirmModal';
import { translate, showMessageToastCustom } from '../../../../../utils/util';
import LinePickingService from '../../../../../services/LinePickingService';
import PaginationScrollNew from '../../../../../components/UI/ListPaginationUlNew';
import { ENUMS, VISIONS } from '../../../../../utils/constants';
import { getUser, getVision } from '../../../../../services/auth';
import PickingService from '../../../../../services/PickingService';
import { Input } from '../../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../../utils/handleChangeHooks';

const PickingListOrder = (props) => {
    const [message, setMessage] = useState({ text: '', cancelGroup: false });
    const [typeMessage, setTypeMessage] = useState('startOrder');
    const [order, setOrder] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [orders, setOrders] = useState([]);
    const [refreshed, setRefreshed] = useState(0);
    const [filter, setFilter] = useState({});
    const [instanceM, setInstanceM] = useState();

    const refreshComponent = () => {
        setRefreshed(refreshed + 1);
    };

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);
        document.addEventListener('expeditionLinePickingRefreshListOrders', refreshComponent);
        return () => {
            document.removeEventListener('expeditionLinePickingRefreshListOrders', refreshComponent);
        };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.data?.items?.length > 0) {
            if (orders.length > 0 && currentPage === 0) {
                setOrders(props.data.items);
            } else {
                setOrders((prevState) => ([...prevState, ...props.data.items]));
            }
        } else {
            setOrders([]);
        }
        // eslint-disable-next-line
    }, [props?.data?.items]);

    useEffect(() => {
        if (orders.length > 0 || currentPage > 0) {
            setCurrentPage(0);
        }
        // eslint-disable-next-line
    }, [props.allOrders]);

    useEffect(() => {
        Object.assign(props.filter, {
            allOrders: props.allOrders,
            almox: props.almox,
            sectors: getVision() === VISIONS.Fiasa ? props.sectors : [],
            ...filter
        });
        props.getOrders(props.filter, {
            PageSize: 25,
            PageIndex: currentPage
        }, () => {
            if (instanceM && props.filter.status.includes(ENUMS.eOrderStatus.WaitingRouteInformation.value)) {
                instanceM[1].close();
            }
        });
        // eslint-disable-next-line
    }, [currentPage, refreshed, props.allOrders]);

    const onSelectItemChange = (event, selectedItem) => {
        event.preventDefault();
        if (selectedItem.status === ENUMS.eOrderStatus.Canceled.value) {
            props.setSelectedOrder(selectedItem);
            return props.history.push({
                pathname: `./order/details`
            });
        }

        if (selectedItem.status === ENUMS.eOrderStatus.Finished.value || selectedItem.status === ENUMS.eOrderStatus.ManuallyFinished.value) {
            return showMessageToastCustom(translate('general:warning'), `O pedido está ${translate(`expedition:${ENUMS.eOrderStatus.Finished.text}`)} `, 8000, 'mdi mdi-alert-circle-outline orange-text');
        }

        if (selectedItem.status === ENUMS.eOrderStatus.NotFound.value) {
            props.setSelectedOrder(selectedItem);
            return props.history.push({
                pathname: './order/notfound'
            });
        }

        if (selectedItem.status === ENUMS.eOrderStatus.WaitingRouteInformation.value) {
            props.setSelectedOrder(selectedItem);
            return props.history.push({
                pathname: `./order/withoutroute`
            })
        }

        if (!selectedItem.orderGroupId || selectedItem.orderGroupId === 0) {
            const mission = selectedItem.items?.find(o => o.status === ENUMS.eOrderItemStatus.Waiting.value || o.status === ENUMS.eOrderItemStatus.InProgress.value)
            if (mission && (selectedItem.status === ENUMS.eOrderStatus.Waiting.value || selectedItem.status === ENUMS.eOrderStatus.WaitingRouteComposition.value || (selectedItem.status === ENUMS.eOrderStatus.InProgress.value && selectedItem.startedBy !== getUser().userName))) {
                const messageDefault = translate('line-picking:linepicking.confirm-order-start');
                setMessage({
                    text: messageDefault.replace('{orderCode}', selectedItem.orderCode).replace('{routeCode}', selectedItem.route?.code || ''),
                    ConfirmModal: false
                });
                setOrder(selectedItem);
                showMessageModal();
            } else if (selectedItem.status === ENUMS.eOrderStatus.InProgress.value) {
                props.setSelectedOrder(selectedItem);
                selectMission(selectedItem);
            }
        }
    };

    const showMessageModal = () => {
        const modal = M.Modal.init(document.getElementById('confirmOrderStart'));
        modal.open();
    };

    const openModalPrinter = () => {
        if (validatePrinter()) {
            const modal = M.Modal.init(document.getElementById('confirmPrinter'));
            modal.open();
        }
    };

    const onConfirmModalPrinter = () => {
        sendPrinter([], true)
    };

    const selectMission = (orderSelect) => {
        const mission = orderSelect.items?.find(o => o.status === ENUMS.eOrderItemStatus.Waiting.value || o.status === ENUMS.eOrderItemStatus.InProgress.value);
        if (mission) {
            props.setSelectedMission(mission);
            props.startOrderItem(orderSelect.orderId, mission.orderItemId, null);
            props.history.push({
                pathname: `./order/missions/${mission.orderItemId}`
            });
        }
    }

    const onConfirmModal = () => {

        if (typeMessage === 'startOrder') {
            if (order.status === ENUMS.eOrderStatus.Waiting.value || order.status === ENUMS.eOrderStatus.WaitingRouteComposition.value || (order.status === ENUMS.eOrderStatus.InProgress.value && order.startedBy !== getUser().userName)) {
                props.startOrder(order.orderId, () => {
                    props.setSelectedOrder(order);
                    selectMission(order);

                });
            }
        } else if (typeMessage === 'unblockOrder') {
            setTypeMessage('startOrder');
            props.unblockOrder(order.orderId, message.cancelGroup, () => {
                setCurrentPage(0);
                refreshComponent();
            });
        }
        setMessage({ text: '', cancelGroup: false });
    };

    const onCancel = () => {
        if (typeMessage === 'unblockOrder' && message.cancelGroup) {
            setTypeMessage('startOrder');
            props.unblockOrder(order.orderId, false, () => {
                setCurrentPage(0);
                refreshComponent();
            });
        }
    };

    const onUnlonckOrder = (event, selectedItem) => {
        setTypeMessage('unblockOrder');
        setOrder(selectedItem);
        if (selectedItem.orderGroupId > 0) {
            message.text = translate('line-picking:linepicking.message-unblock');
            if (getVision() === VISIONS.Fiasa) {
                message.text = message.text + ' para qualquer usuário?'
            }
            message.cancelGroup = true;
        }
        else {
            const messageDefault = translate('line-picking:linepicking.ublock-route-order');
            message.text = messageDefault.replace('{orderCode}', selectedItem.orderCode).replace('{route}', selectedItem.route?.code || '')
            if (getVision() === VISIONS.Fiasa) {
                message.text = message.text + ' para qualquer usuário?'
            }
            message.cancelGroup = false;
        }
        setMessage(message);
        showMessageModal();
    };

    const onUserTransfer = (event, selectedItem) => {
        props.setSelectedOrder(selectedItem);
        props.history.push({
            pathname: `orders/${selectedItem.orderCode}/usertransfer`
        });
    };

    const onPutOnHold = (event, selectedItem) => {
        props.changeStatusOrder(selectedItem.orderId, ENUMS.eOrderStatus.OnHold.value, () => refreshComponent());
    };

    const onPutOnPlay = (event, selectedItem) => {
        props.changeStatusOrder(selectedItem.orderId, ENUMS.eOrderStatus.Waiting.value,
            () => {
                onUnlonckOrder(event, selectedItem);
                refreshComponent();
            }
        );
    };

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onFilter = () => {
        setCurrentPage(0);
        refreshComponent();
    }

    const validatePrinter = () => {
        if (!props.user.printer) {
            showMessageToastCustom(translate('general:warning'), translate('validations:select-resource'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return false
        }
        return true;
    }

    const sendPrinter = (row, printModal) => {
        if (validatePrinter()) {
            if (navigator.userAgent !== 'logisticspwa' && props.user.printer?.connectionType === ENUMS.ePrinterConnectionType.Bluetooth.value) {
                showMessageToastCustom(translate('general:warning'), translate('validations:service-not-available'), 3000, 'mdi mdi-alert-circle-outline red-text');
            } else {
                let filterModal = {};
                if (printModal) {
                    Object.assign(filterModal, {
                        allOrders: props.allOrders,
                        almox: props.almox,
                        ...filter,
                        ...props.filter,
                    });
                }
                props.printOrders({
                    ...filterModal,
                    orderIds: row,
                    allPrint: printModal,
                    printer: props.user.printer
                }, (response) => {
                    console.log(response)
                });
            }
        }
    }

    const onFilterKanban = (alert) => {
        if (alert === filter.typeAlert) {
            filter.typeAlert = null
        } else {
            filter.typeAlert = alert;
        }
        setFilter({ ...filter });
        refreshComponent();
    }

    return (
        <div id="listLPorders" className="container-fluid">
            {
                (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && (
                    <>
                        <div style={{ marginLeft: '15px' }}>
                            <span>{translate('line-picking:linepicking.total-count')} {props.data.totalCount}</span>
                            {
                                getVision() === VISIONS.Fiasa && props.location?.state?.printerLabel &&
                                <>
                                    <span
                                        className="title sixth-text-color"
                                        style={{ float: 'left', cursor: 'pointer', paddingRight: '3px' }}
                                        onClick={openModalPrinter}
                                    ><i className="material-icons">local_printshop</i>
                                    </span>
                                    <span
                                    ><i className={`mdi mdi-24px ${filter.typeAlert === ENUMS.eTypeAlert.Blue.value ? 'mdi-36px' : 'mdi-24px'} mdi-circle`}
                                        onClick={() => onFilterKanban(ENUMS.eTypeAlert.Blue.value)}
                                        style={{ color: ENUMS.eTypeAlert.Blue.color, paddingLeft: '10px' }} />
                                    </span>
                                    <span
                                    ><i className={`mdi mdi-24px ${filter.typeAlert === ENUMS.eTypeAlert.Yellow.value ? 'mdi-36px' : 'mdi-24px'} mdi-circle`}
                                        onClick={() => onFilterKanban(ENUMS.eTypeAlert.Yellow.value)}
                                        style={{ color: ENUMS.eTypeAlert.Yellow.color, paddingLeft: '10px' }} />
                                    </span>
                                    <span
                                    ><i className={`mdi mdi-24px ${filter.typeAlert === ENUMS.eTypeAlert.Red.value ? 'mdi-36px' : 'mdi-24px'} mdi-circle`}
                                        onClick={() => onFilterKanban(ENUMS.eTypeAlert.Red.value)}
                                        style={{ color: ENUMS.eTypeAlert.Red.color, paddingLeft: '10px' }} />
                                    </span>
                                </>
                            }
                        </div>
                    </>)
            }
            {props.filter.status.includes(ENUMS.eOrderStatus.WaitingRouteInformation.value) &&
                <div className="container" style={{ marginTop: '0px' }}>
                    <ul id='collapsible' className="collapsible">
                        <li className='active'>
                            <div className="collapsible-header">
                                {translate('expedition:picking.filter')}
                            </div>
                            <div className="collapsible-body" style={{ padding: '10px' }}>
                                <div className="row">
                                    <div className="input-field padding col s12 l5">
                                        <i className='mdi mdi-filter-outline posfix' style={{ top: '0rem' }} onClick={onFilter} />
                                        <Input
                                            id="orderItemCode"
                                            name='orderItemCode'
                                            placeholder={translate('line-picking:linepicking.requisition-number')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className=" input-field padding col s12 l5">
                                        <i className='mdi mdi-filter-outline posfix' style={{ top: '0rem' }} onClick={onFilter} />
                                        <Input
                                            id="partNumber"
                                            name='partNumber'
                                            placeholder={translate('line-picking:linepicking.drawing')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field padding col s12 l5">
                                        <i className='mdi mdi-filter-outline posfix' style={{ top: '0rem' }} onClick={onFilter} />
                                        <Input
                                            id="orderCode"
                                            name='orderCode'
                                            placeholder={translate('line-picking:transmission.call')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            }
            <PaginationScrollNew
                page={props.data?.totalPages}
                current={{ currentPage, setCurrentPage }}
                data={
                    //filter((i) => i.items?.filter((j) => j.status === ENUMS.eOrderItemStatus.WaitingRepicking.value).length <= 0).
                    orders.map((item) => {
                        return (
                            <ListItemOrder
                                key={`o-${item.orderId}-${item.status}`}
                                route={`./order/${item.orderCode}/missions`}
                                data={item}
                                kanban={props.location?.state?.kanban}
                                checkPrint={props.location?.state?.printerLabel && getVision() === VISIONS.Fiasa}
                                onSelectChange={(event) => onSelectItemChange(event, item)}
                                onClickUnlonckOrder={onUnlonckOrder}
                                onClickUserTransfer={onUserTransfer}
                                onClickPutOnHold={onPutOnHold}
                                onPutOnPlay={onPutOnPlay}
                                sendPrinter={sendPrinter}
                            />
                        );
                    })
                }
            />
            <ConfirmModal
                id="confirmOrderStart"
                data={{ title: translate('validations:attention'), message: message?.text || '' }}
                onCancel={!typeMessage === 'startOrder' ? onConfirmModal : onCancel}
                onConfirm={!typeMessage === 'startOrder' ? onCancel : onConfirmModal}
                btnConfirm={typeMessage === 'startOrder' ? translate('general:confirm') : 'APENAS ESTE'}
                btnCancel={typeMessage === 'startOrder' ? translate('general:cancel') : 'TODOS'}
            />
            <ConfirmModal
                id="confirmPrinter"
                data={{ title: translate('validations:attention'), message: `Deseja imprimir ${props.data.totalCount} etiquetas?` }}
                onConfirm={onConfirmModalPrinter}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        almox: state.linePickingReducer.almox,
        sectors: state.linePickingReducer.sectors,
        filter: state.linePickingReducer.filter,
        orders: state.linePickingReducer.orders,
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedOrder: (order) => {
            dispatch(actionsLinePicking.selectOrder(order));
        },
        setSelectedMission: (mission) => {
            dispatch(actionsLinePicking.selectMission(mission));
        },
        getOrders: (filter, pagination, callback) => {
            dispatch(LinePickingService.getOrders(filter, pagination, callback));
        },
        startOrder: (orderId, callback) => {
            dispatch(LinePickingService.startOrder(orderId, callback));
        },
        startOrderItem: (orderId, orderItemId, callback) => {
            dispatch(LinePickingService.startOrderItem(orderId, orderItemId, callback));
        },
        unblockOrder: (orderId, changeGroup, callback) => {
            dispatch(LinePickingService.unblock(orderId, changeGroup, callback));
        },
        changeStatusOrder: (orderId, status, callback) => {
            dispatch(PickingService.changeStatusOrder(orderId, status, callback));
        },
        printOrders: (data, callback) => {
            dispatch(PickingService.printOrders(data, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PickingListOrder)));
